export type StateValidator = (value: unknown) => boolean;

export function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isNullableString(value: unknown): value is string | null {
  return value === null || isString(value);
}

export function isFiniteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function isArrayOf<T>(
  value: unknown,
  validator: (item: unknown) => item is T
): value is T[] {
  return Array.isArray(value) && value.every(validator);
}

export function hasValidOptionalProperty(
  value: Record<string, unknown>,
  property: string,
  validator: (propertyValue: unknown) => boolean
) {
  return !(property in value) || validator(value[property]);
}
